var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "espacamento", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            { staticClass: "cardHeader" },
            [
              _c("b", [_vm._v("Dados do Cálculo:")]),
              _vm.isVisualizar && _vm.showAnteciparParcelas
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.antecipacaoParcela }
                    },
                    [_vm._v("Solicitar Antecipação/Quitação de custas de VTN")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { attrs: { id: "line" } }),
          _vm.exibeObs
            ? _c("p", { staticStyle: { color: "red", "font-size": "13px" } }, [
                _vm._v(
                  "Em caso de pagamento à vista, observar o Valor Final do Imóvel (VFI)."
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "center" },
            [
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Munícipio:",
                      content:
                        _vm.dadosVtn.pvtn.municipio
                          .nomeComCodigoEstadoFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Módulo fiscal do Município (MF):",
                      content: _vm.dadosVtn.pvtn.municipio.mf,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Área Requerida (A):",
                      content: _vm.dadosVtn.areaRequeridaFormatada,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Número de módulos fiscais:",
                      content: _vm.dadosVtn.nmoduloFiscalFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.numeroModulosFiscais(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Percentual a ser aplicado sobre o VTN:",
                      content: _vm.dadosVtn.percentualAplicadoFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.percentualAplicadoVtn(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Coeficiente Angular:",
                      content: _vm.dadosVtn.coeficienteAngularFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.coeficienteAngular(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Coeficiente Linear:",
                      content: _vm.dadosVtn.coeficienteLinearFormatado,
                      toolTip: "left-end",
                      textIcon: _vm.coeficienteLinear(),
                      contentAlignRight: true
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "flex", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Valor mínimo da Pauta de VTN (PVTN):",
                      content: "" + _vm.dadosVtn.pvtn.vtnPorHaMinFormatado,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Percentual do bônus utilizado no cálculo:",
                      content: _vm.intervaloPercentual,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Prazo mínimo de inalienabilidade do imóvel:",
                      content: _vm.getPrazoMinimo,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Pagamento:",
                      content: "até 20 (vinte) parcelas anuais e sucessivas",
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Juros:",
                      content: _vm.jurosText,
                      toolTip: "left-end",
                      textIcon: _vm.juros(),
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Carência:",
                      content: _vm.carenciaText,
                      contentAlignRight: true
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Valor Final do Imóvel (VFI):",
                      content: _vm.formataMoeda(_vm.dadosVtn.valorFinalImovel),
                      contentAlignRight: true
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm.exibeCardObs
        ? _c("observacoes", { staticClass: "espacamento" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b893ad52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b893ad52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/ConfirmarDados.vue
// module id = null
// module chunks = 